import {createContext} from 'react'
import {ModalReprocessKycHandler} from 'types'

export const ModalReprocessKycContext = createContext<ModalReprocessKycHandler | undefined>(
  undefined,
)
